<template>
    <form @submit.prevent="create">

        <input-text v-model="name" class="mb-4" required>
            Gruppenname
        </input-text>
        <div class="grid grid-cols-2 gap-4">
            <user-list-selection v-show="availableUsers.length > 0" v-model="checkedUsers" :users="availableUsers"></user-list-selection>

            <div class="mb-8" v-show="availableCategories.length > 0">
                Bestätigung frei buchbare Kategorien in der Gruppe:
                <div v-for="u in availableCategories">
                    <label>
                        <input class="mr-2" type="checkbox" :value="u.id" v-model="checkedCategories">
                        {{ u.name }}
                    </label>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <button-primary type="submit">
                <template slot="icon"><i class="fa fa-save"></i></template>
                Speichern
            </button-primary>
        </div>

    </form>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";
import UserListSelection from "./UserListSelection.vue";

export default {
    name: "UserGroupCreate",
    components: {UserListSelection, InputText, ButtonPrimary},
    data: () => ({
        loading: false,
        name: '',
        checkedUsers: [],
        availableUsers: [],
        checkedCategories: [],
        availableCategories: [],
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            window.axios.get('/admin/users/available')
                .then(result => {
                    this.loading = false;
                    this.availableUsers = result.data.data;
                })
            window.axios.get('/admin/bookable_categories')
                .then(result => {
                    this.loading = false;
                    this.availableCategories = result.data.data;
                })
        },
        create() {
            window.axios.post('/admin/user_groups', {
                name: this.name,
                users: this.checkedUsers,
                confirmation_free_bookable_categories: this.checkedCategories
            }).then(() => {
                this.loading = false;
                this.$emit('created');
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
